import { render, staticRenderFns } from "./RelatedEvents.vue?vue&type=template&id=4e699fe5&scoped=true&"
import script from "./RelatedEvents.vue?vue&type=script&lang=ts&"
export * from "./RelatedEvents.vue?vue&type=script&lang=ts&"
import style0 from "./RelatedEvents.vue?vue&type=style&index=0&id=4e699fe5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e699fe5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e699fe5')) {
      api.createRecord('4e699fe5', component.options)
    } else {
      api.reload('4e699fe5', component.options)
    }
    module.hot.accept("./RelatedEvents.vue?vue&type=template&id=4e699fe5&scoped=true&", function () {
      api.rerender('4e699fe5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/webshop/components/related/RelatedEvents.vue"
export default component.exports